export default {
  padding: {
    paddingTop: 0,
  },
};
